import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import Lenis from "lenis";

document.addEventListener('DOMContentLoaded', () => {
    gsap.registerPlugin(ScrollTrigger);

    // Smooth Scroll
    const lenis = new Lenis();

    lenis.on("scroll", ScrollTrigger.update);

    gsap.ticker.add((time) => {
        lenis.raf(time * 1000);
    });

    gsap.ticker.lagSmoothing(0);

    // Illustrated banner icons
    // Rotate the decorative icons while the pointer is over the banner, and
    // return them to rest when it leaves. `.illustration-hover` is a general
    // class, so a page can have more than one of these banners - wire each
    // one up independently.
    //
    // Their resting angles are set in CSS (Tailwind's `rotate-*`), and GSAP
    // treats `rotation` as an ABSOLUTE target, reading that resting angle as
    // the tween's start. Animating straight to a small number would therefore
    // spin the spoon (155deg) and fork (-135deg) most of the way around, so
    // capture each icon's rest angle up front and animate relative to it.
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    if (!reducedMotion) {
        document.querySelectorAll(".illustration-hover").forEach((illustrated) => {
            const icons = gsap.utils.toArray(illustrated.querySelectorAll(".icon"));
            if (!icons.length) return;

            // Degrees to rotate on hover, in markup order:
            // dragon-fruit, spoon, apple, orange, fork
            // A single value tilts the whole group together; give each icon its
            // own entry to have them rotate independently.
            const HOVER_ROTATION = [-10, 12, -15, 10, -10];

            const restAngle = icons.map((icon) => gsap.getProperty(icon, "rotation"));

            const rotateTo = (hovering) =>
                gsap.to(icons, {
                    rotation: (i) => restAngle[i] + (hovering ? HOVER_ROTATION[i % HOVER_ROTATION.length] : 0),
                    duration: 0.7,
                    ease: "power2.out",
                    stagger: 0.05,
                    overwrite: "auto",
                });

            illustrated.addEventListener("mouseenter", () => rotateTo(true));
            illustrated.addEventListener("mouseleave", () => rotateTo(false));
        });
    }

    // Cursor Follow
    const parents = document.querySelectorAll(".cursor-parent");

    parents?.forEach((parent) => {
        const follower = parent.querySelector(".cursor-follow");
        if (!follower) return;

        const pos = { x: parent.offsetWidth / 2, y: parent.offsetHeight / 2 };
        const mouse = { ...pos };
        const speed = 0.2;
        const fpms = 60 / 1000;

        parent.addEventListener("pointermove", (e) => {
            const rect = parent.getBoundingClientRect();
            mouse.x = e.clientX - rect.left;
            mouse.y = e.clientY - rect.top;
        });

        const xSet = gsap.quickSetter(follower, "x", "px");
        const ySet = gsap.quickSetter(follower, "y", "px");

        const followerOffset = {
            x: follower.offsetWidth / 2,
            y: follower.offsetHeight / 2,
        };

        gsap.ticker.add((time, deltaTime) => {
            const delta = deltaTime * fpms;
            const dt = 1.0 - Math.pow(1.0 - speed, delta);

            pos.x += (mouse.x - pos.x) * dt;
            pos.y += (mouse.y - pos.y) * dt;

            xSet(pos.x - followerOffset.x); // center on mouse
            ySet(pos.y - followerOffset.y);
        });
    });
});
